import React from 'react';
import { useTranslation } from 'react-i18next';
import { DsTag, DsTooltip } from '@tokenyico/design-system/dist/reactJS';

export default ({ status, ...rest }) => {
  const { t } = useTranslation();

  const versions = {
    PENDING_PAYMENT: 'warning',
    PAYMENT_RECEIVED: 'warning',
    CONFIRMED: 'success',
    CANCELED_BY_INVESTOR: 'error',
    CANCELED_BY_ISSUER: 'error',
    REFUNDED: 'info',
    MINTED: 'info',
    MINT_IN_PROGRESS: 'info',
    MINT_FAILED: 'error',
  };

  const icons = {
    PENDING_PAYMENT: 'pending',
    PAYMENT_RECEIVED: 'pending',
    CONFIRMED: 'verified',
    CANCELED_BY_INVESTOR: 'cross-circle',
    CANCELED_BY_ISSUER: 'cross-circle',
    REFUNDED: 'undo',
    MINTED: 'circle-plus',
    MINT_IN_PROGRESS: 'loader-circle',
    MINT_FAILED: 'cross-circle',
  };

  const label = {
    PENDING_PAYMENT: t('shared.pending'),
    PAYMENT_RECEIVED: t('shared.paymentReceived'),
    CONFIRMED: t('shared.orderConfirmed'),
    CANCELED_BY_INVESTOR: t('shared.canceledByYou'),
    CANCELED_BY_ISSUER: t('shared.canceledByIssuer'),
    REFUNDED: t('shared.refunded'),
    MINTED: t('shared.minted'),
    MINT_IN_PROGRESS: t('shared.mintInProgress'),
    MINT_FAILED: t('shared.mintFailed'),
  };
  const isVisibleOnHover = [
    'MINTED',
    'CONFIRMED',
    'CANCELED_BY_ISSUER',
    'PAYMENT_RECEIVED',
  ].includes(status);

  return (
    <DsTooltip
      text={isVisibleOnHover ? t(`shared.${status}OrderDetails`) : ''} // use empty string to get rid of missing translation error
      isVisibleOnHover={isVisibleOnHover}
    >
      <DsTag
        label={label[status]}
        version={versions[status] || 'default'}
        icon={icons[status]}
        iconSize="14px"
        size="xs"
        style={{ cursor: 'pointer' }}
        {...rest}
      />
    </DsTooltip>
  );
};
